import { render, staticRenderFns } from "./changeGroup.vue?vue&type=template&id=0604120e&scoped=true&"
import script from "./changeGroup.vue?vue&type=script&lang=js&"
export * from "./changeGroup.vue?vue&type=script&lang=js&"
import style0 from "./changeGroup.vue?vue&type=style&index=0&id=0604120e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604120e",
  null
  
)

export default component.exports